import $ from 'jquery';

if ($("#video_landing_page").length) {
	$('[data-toggle="tooltip"]').tooltip();

	$("#copyToClipboard").on("click", function (e) {
		e.preventDefault();

		var url = $(this).attr('data-url');

			var $temp = $("<input>");
			$("body").append($temp);
			$temp.val(url).select();

			document.execCommand("copy");
			$temp.remove();
			$("#copyToClipboard").hide();
			$("#copied").show();

			setTimeout(() => {
				$("#copyToClipboard").show();
				$("#copied").hide();
			}, 1500);
	});
}
